import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CategoryBlogList from './category_blog_list';
import CategoryBlogDetail from './category_blog_detail';

class CategoryBlog extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CategoryBlogList/>;
    }else{
      if(params.id===undefined){
        view = <CategoryBlogDetail/>;
      }else{
        view = <CategoryBlogDetail action={params.action}/>;
      }
    }
    return (
      <div className="category-page">{view}</div>
    );
  }
}

CategoryBlog.contextTypes = {
  router: PropTypes.object
};

export default CategoryBlog;
